<template>
    <div
        :style="componentStyles"
        class="o-item-details-compact"
    >
        <div class="item-details-compact-wrapper">
            <div class="item-details-compact-logo">
                <img
                    :src="icon"
                    class="item-details-compact-image"
                >
            </div>
            <div class="item-details-compact-title-wrapper">
                <div class="item-details-compact-title">
                    {{ name }}
                </div>
            </div>
        </div>
        <button
            type="button"
            class="item-details-compact-button"
            @click="$emit('expanded', true)"
        >
            <span class="item-details-compact-button-placeholder">
                <AFloorInfo
                    :text="floor"
                />
            </span>
        </button>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

import AFloorInfo from '../../atoms/a-floor-info';

export default {
    name: "OItemDetailsCompact",
    components: {
        AFloorInfo
    },
    props: {
        itemId: {
            type: Number,
            required: true
        },
        view: {
            type: String,
            default: ''
        }
    },
    computed: {
        ...mapGetters([
            't',
            'getObject',
            'getMapConfigProp'
        ]),
        item() {
            return this.getObject(this.itemId) || null;
        },
        icon() {
            return this.item.files.icon || '';
        },
        name() {
            return this.t(this.item, 'name') || '';
        },
        floor() {
            return this.t(this.item, 'floor') || '';
        },
        componentParams() {
            return this.getMapConfigProp(`views.${this.view}.mainFrame.OGuideSidebar.params.OItemDetailsCompact.params`) || null;
        },
        componentStyles() {
            return this.getMapConfigProp(`views.${this.view}.mainFrame.OGuideSidebar.params.OItemDetailsCompact.styles`) || null;
        }
    }
}
</script>

<style lang="scss">
@import "theme";
</style>
